import { useCallback, useState } from 'react'
import type { PropsWithChildren } from 'react'
import { useAuth } from '@/core/auth/hooks/useAuth'
import { useSessionTimeout } from '@/core/auth/hooks/useSessionTimeout'
import { SessionTimeoutModal } from '@/core/auth/components/SessionTimeoutModal'
import { Sidebar } from '@/shared/components/layout/Sidebar'

export function AppLayout({ children }: PropsWithChildren) {
  const { logout } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)

  const handleTimeout = useCallback(() => { void logout() }, [logout])
  const { showWarning, countdown, continueSession } = useSessionTimeout({ onTimeout: handleTimeout })

  return (
    <div className="flex min-h-svh bg-white">
      <Sidebar isOpen={menuOpen} onClose={() => setMenuOpen(false)} />
      <main
        className="
          flex min-h-0 min-w-0 flex-1 flex-col overflow-x-hidden overflow-y-auto
          h-[calc(100svh-2rem)] m-4 ml-0 rounded-(--radius-lg)
        "
      >
        <div className="flex h-12 w-full shrink-0 items-center justify-between bg-white px-4 shadow-[0_1px_4px_rgba(0,0,0,0.1)] md:hidden">
          <button
            type="button"
            className="inline-flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border-0 bg-transparent p-0 text-[#05141f]"
            aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            {menuOpen ? (
              <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M6 6l12 12M6 18L18 6" />
              </svg>
            ) : (
              <svg className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
        {children}
      </main>
      {showWarning && (
        <SessionTimeoutModal
          countdown={countdown}
          onContinue={continueSession}
          onLogout={() => void logout()}
        />
      )}
    </div>
  )
}
